import _ from 'lodash';

import clamp from './clamp';

export function shiftInputByValue(
  ticks: number[] | undefined,
  strideLength: number | undefined,
  direction: number,
  v: number,
  min: number | undefined,
  max: number | undefined
) {
  let newValue;
  if (ticks && ticks.length > 0) {
    if (strideLength) {
      // Stride length counts ticks, not raw units, so the result is always a
      // valid tick. Start from the current tick, or the nearest one when the
      // value sits between ticks.
      let currentIndex = ticks.indexOf(v);
      if (currentIndex === -1) {
        const closest = ticks.reduce((prev, curr) =>
          Math.abs(curr - v) < Math.abs(prev - v) ? curr : prev
        );
        currentIndex = ticks.indexOf(closest);
      }
      // The settings UI enforces integers >= 1, but the stride arrives from
      // persisted panel config (JSON), which can carry anything. Normalize to
      // a whole, non-zero tick count: rounding the signed product would move
      // different distances up vs down, and a sub-0.5 stride would round to 0
      // and freeze the control
      const strideTicks = Math.max(1, Math.round(strideLength));
      const finalIndex = clamp(currentIndex + direction * strideTicks, {
        min: 0,
        max: ticks.length - 1,
      });
      newValue = ticks[finalIndex];
    } else {
      // When no stride length is set get the next valid step
      const currentIndex = _.sortedIndex(ticks, v);
      const finalIndex = clamp(currentIndex + direction, {
        min: 0,
        max: ticks.length - 1,
      });
      newValue = ticks[finalIndex];
    }
  } else {
    newValue = v + direction * (strideLength ?? 1);
    newValue = clamp(newValue, {min, max});
  }
  return newValue;
}
